import module from 'module';

const templateUrl = require('./form-section-field.template.html');

module.component('formSectionField', {
  templateUrl,
  transclude: true,
  bindings: {
    fieldTitle: '<',
    autoWidthTitle: '<'
  }
});
